import clsx from 'clsx'
import React, {FC} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {
  HeaderNotificationsMenu,
  HeaderUserMenu,
  QuickLinks,
  Search,
  ThemeModeSwitcher,
} from '../../../partials'
import {useLayout} from '../../core'
import { imageendpoint } from '../../../../app/modules/auth/core/_requests'
import { useEffect, useState } from 'react'
import { GET_DATA } from '../../../../app/modules/auth/core/_requests'
import axios from 'axios'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const base = GET_DATA

const Topbar: FC = () => {
  const {config} = useLayout()

  const [actores, setListadoActores] = useState([]);
  
  useEffect(() => {
    const obtenerPersonajes = async ()=> {
      const url = base;
      const result = await axios.get(url)
      setListadoActores(result.data)
    }
    obtenerPersonajes()
  },[]);

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {actores.length === 0 && <></>}
        {
          actores.map((personas, i)=>{
            return(
              <div className='d-flex align-items-stretch flex-shrink-0' key={i}>
              {/* Search */}
              <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
                <Search />
              </div>
        
              {/* begin::Theme mode */}
              <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
                <ThemeModeSwitcher
                  toggleBtnClass={clsx('btn-active-light-primary btn-custom', toolbarButtonHeightClass)}
                />
              </div>
              {/* end::Theme mode */}
        
              {/* begin::User */}
              <div
                className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
                id='kt_header_user_menu_toggle'
              >
                {/* begin::Toggle */}
                <div
                  className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
                  data-kt-menu-trigger='click'
                  data-kt-menu-attach='parent'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-flip='bottom'
                >
                  <img src={imageendpoint+personas['foto']}></img>
                </div>
                <HeaderUserMenu />
                {/* end::Toggle */}
              </div>
              {/* end::User */}
        
              {/* begin::Aside Toggler */}
              {config.header.left === 'menu' && (
                <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
                  <div
                    className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
                    id='kt_header_menu_mobile_toggle'
                  >
                    <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
                  </div>
                </div>
              )}
            </div>
            )
          })
        }
    </div>
  )
}

export {Topbar}
